import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import FormModal from "../../Components/modal/FormModal";
import { handleApiErrors, validationRegex } from "../../Utils/Utils";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import StateService from "../../Services/StateService";
import { Modal, ModalBody } from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import ApiConstants from "../../Utils/ApiConstant";
import { AuthContext } from "../../Context/authContext";

const StateMaster = () => {
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [searchQuery, setSearchQuery] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const {user }= useContext(AuthContext)

  // Form validation schema using Yup
  const schema = Yup.object().shape({
    name: validationRegex.required,
  });

  const {
    register: registerAdd,
    handleSubmit: handleSubmitAdd,
    formState: { errors: errorsAdd },
    reset: resetAdd,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
    },
  });

  const {
    register: registerEdit,
    handleSubmit: handleSubmitEdit,
    formState: { errors: errorsEdit },
    reset: resetEdit,
    setValue: setEditValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
    },
  });

  // Function to handle opening add modal
  const handleOpenAddModal = () => {
    resetAdd(); // Reset form fields when opening Add modal
    setShowAddModal(true);
  };

  // Function to handle opening edit modal
  const handleOpenEditModal = (item) => {
    setEditValues("name", item.name);
    setEditData(item);
    setShowEditModal(true);
  };

  const bulkUploadData = async (file) => {
    try {
      // debugger
      await StateService.bulkUploadData(file);
      toast.success("Data Uploaded successfully");
      setShowBulkUploadModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await StateService.get(offset, limit, searchQuery || "");
      setData(response.data);

      setAvailableDataCount(response.availableDataCount);

      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const addDataApiTask = async (data) => {
    try {
      await StateService.create(data.name);
      setShowAddModal(false);
      toast.success("State added successfully");
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const updateApiTask = async (params) => {
    try {
      await StateService.update(editData._id, params.name.trim());

      setShowEditModal(false);
      toast.success("State updated successfully");

      var updatedData = data;
      const index = updatedData.findIndex((item) => item._id === editData._id);
      updatedData[index].name = params.name.trim();
      setData(updatedData);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleData = async (id) => {
    try {
      await StateService.delete([id]);
      toast.success("State Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteMultipleData = async () => {
    try {
      if (data.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item._id);
          }
        });
      }
      await StateService.delete(itemsToDelete);
      toast.success("States Deleted successfully");
      setShowDeleteModal(false);

      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const ChangeStatus = async (id, status) => {
    try {
      await StateService.changeStatus(id, status);
      toast.success("State Status Updated successfully");
      var updatedData = data;
      updatedData[updatedData.findIndex((item) => item._id === id)].is_active =
        status;
      setData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  useEffect(() => {
    fetchData();
  }, [offset]);

  return (
    <div>
      <div>
        <div className="content" data-number="1">
          <div className="mb-3 d-flex justify-content-between align-items-center">
            <h1 className="black fs-18 fw-600 mb-0">STATE MASTER</h1>
            <div className="d-flex">
              <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
              <h4 className="fs-12 fw-500 primary mb-0">State Master</h4>
            </div>
          </div>

          <div className="table_container" style={{ display: "block" }}>
          <h1 className="black fs-18 fw-600 mb-0">State List</h1>
            <div className="table_title">
              <div className="table_headings mt-2">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                    pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                onClick={() => {

                  const stateMasterPrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "State Master"
                  );
                  if (!stateMasterPrivilege?.delete) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning("You don't have permission to delete state list.");
                    return;
                  }

                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
                <div className="d-flex gap-4 align-items-center statemasterrespo">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="search_box search_bar"
                      placeholder="Search"
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <Image
                      src={SvgImages.search}
                      style={ImageFilters.gray}
                      className="search_icon"
                      alt="Search Icon"
                      height="20px"
                    />
                  </div>
                  <ButtonWithIcon
                    text={"Add State"}
                    icon={SvgImages.plus}
                    onClick={()=>{
                      const stateMasterPrivilege = user?.setPrivileges?.find(
                        (priv) => priv.parameter === "State Master"
                      );
  
                      if (stateMasterPrivilege?.create) {
                        handleOpenAddModal(); // Open modal if create is true
                      } else {
                        toast.warning("You don't have permission to add state.");
                      }
                    }}
                  />
                  <ButtonWithIcon
                    text={"Bulk Upload"}
                    icon={SvgImages.plus}
                    onClick={() => {
                      const stateMasterPrivilege = user?.setPrivileges?.find(
                        (priv) => priv.parameter === "State Master"
                      );
  
                      if (stateMasterPrivilege?.create) {
                        
                        setShowBulkUploadModal(true); // Open modal if create is true
                      } else {
                        
                        toast.warning("You don't have permission to bulk upload.");
                      }
                    }}
                  />
                </div>
              </div>

            
            </div>

            <div style={{ overflowX: "auto" }}>
              <table
                className="table mb-0"
                id="dtHorizontalExample"
                cellSpacing="0"
                width="100%"
              >
                <thead>
                  <tr className="table_heading">
                    <th scope="col" style={{ width: "5%" }}>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          style={{ height: "16px", aspectRatio: 1 }}
                          checked={
                            data?.length > 0 &&
                            data?.findIndex((item) => !item.isChecked) == -1
                          }
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData.map((element) => {
                              element.isChecked = value.target.checked;
                            });
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </th>
                    <th scope="col" style={{ width: "10%" }}>
                      Sr No.
                    </th>
                    <th scope="col" style={{ width: "40%" }}>
                      State
                    </th>
                    <th scope="col" style={{ width: "25%" }}>
                      Status
                    </th>
                    <th scope="col" style={{ width: "10%" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg_light">
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <label className="d-flex align-items-center justify-content-center">
                          <input
                            className="cursor-pointer"
                            type="checkbox"
                            checked={item.isChecked || false}
                            style={{ height: "16px", aspectRatio: 1 }}
                            onChange={(value) => {
                              var updatedData = data;
                              updatedData[index].isChecked =
                                value.target.checked;
                              setData([...updatedData]);
                            }}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                      <td>{limit * offset + (index + 1)}</td>
                      <td>{item.name}</td>
                      <td>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={item.is_active}
                            onChange={() => {

                              const stateMasterPrivilege = user?.setPrivileges?.find(
                                (priv) => priv.parameter === "State Master"
                              )
                              if (!stateMasterPrivilege?.update) {
                                // If the user does not have delete permission, show a toast warning
                                toast.warning("You don't have permission to update the status.");
                                return;
                              }

                              setShowConfirmationModal(true);
                              setStatusChangeData(item);
                            }}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td>
                        <div className="d-flex gap_8">
                          <a
                            onClick={() =>{
                              const stateMasterPrivilege = user?.setPrivileges?.find(
                                (priv) => priv.parameter === "State Master"
                              );
    
                              if (!stateMasterPrivilege?.update) {
                                // If the user does not have delete permission, show a toast warning
                                toast.warning("You don't have permission to edit mock test.");
                                return;
                              }
                           handleOpenEditModal(item)
                          }}
                            className="edit_icons cursor-pointer"
                          >
                            <Image
                              src={SvgImages.edit}
                              style={ImageFilters.green}
                              className="add_icons"
                              alt="Edit Icon"
                            />
                          </a>
                          <a
                            className="delete_icons cursor-pointer"
                            onClick={() => {
                              const stateMasterPrivilege = user?.setPrivileges?.find(
                                (priv) => priv.parameter === "State Master"
                              );
                              if (!stateMasterPrivilege?.delete) {
                                // If the user does not have delete permission, show a toast warning
                                toast.warning("You don't have permission to delete state.");
                                return;
                              }

                              setDeleteId(item._id);
                              setIsMultipleDelete(false);
                              setShowDeleteModal(true);
                            }}
                          >
                            <Image
                              src={SvgImages.deleteIcon}
                              style={ImageFilters.red}
                              alt="Delete Icon"
                            />
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            
            </div>
            {generatePaginationFooter(
                availableDataCount,
                limit,
                offset,
                setOffset
              )}
          </div>
        </div>
      </div>

      {/* Add State Modal */}
      <FormModal
        title={"Add State"}
        showModal={showAddModal}
        setShowModal={setShowAddModal}
        submitClickAction={handleSubmitAdd(addDataApiTask)}
        children={
          <form onSubmit={handleSubmitAdd(addDataApiTask)}>
            {/* Custom Text Field for Class */}
            <CustomTextField
              labelTitle="State"
              placeholder="Enter state name"
              name="name"
              id="name"
              showError={errorsAdd?.name}
              errorMessage={errorsAdd?.name?.message}
              register={registerAdd}
              additionalClasses="profile_edit"
              showMandatory={true}
            />
          </form>
        }
      />

      {/* Edit State Modal */}
      <FormModal
        title={"Edit State"}
        showModal={showEditModal}
        submitButtonText="Update"
        submitButtonIcon={SvgImages.tick_mark}
        setShowModal={setShowEditModal}
        submitClickAction={handleSubmitEdit(updateApiTask)}
        children={
          <form onSubmit={handleSubmitEdit(updateApiTask)}>
            {/* Custom Text Field for Class */}
            <CustomTextField
              labelTitle="State"
              placeholder="Enter state name"
              name="name"
              id="name"
              showError={errorsEdit?.name}
              errorMessage={errorsEdit?.name?.message}
              register={registerEdit}
              additionalClasses="profile_edit"
              showMandatory={true}
            />
          </form>
        }
      />

      {/* Delete State Modal */}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected data?"
            : "Are you sure want to delete this data?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleData() : deleteSingleData(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />

      {/* Change State Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(getStatusChangeData._id, !getStatusChangeData.is_active);
        }}
        theme={ConfirmationModalTheme.warning}
      />

      <BulkUploadModal
        showModal={showBulkUploadModal}
        setShowModal={setShowBulkUploadModal}
        onSuccess={(file) => bulkUploadData(file)}
      />
    </div>
  );
};

export default StateMaster;

const BulkUploadModal = ({ showModal, setShowModal, onSuccess }) => {
  const fileTypes = ["csv", "xlsx", "xls"];

  const handleChange = (file) => {
    onSuccess(file);
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      dialogClassName="my-0"
      centered // Center the modal vertically and horizontally
      aria-labelledby="exampleModalToggleLabel2"
      contentClassName="p-0 bg-transparent border-0 shadow-none m-0"
    >
      <ModalBody className="p-0">
        <div className="w-100 d-flex flex-column">
          <div className="modal-content p-4">
            <div className="d-flex gap-3 flex-column justify-content-center align-items-center">
              <h1 className="black fs-18 fw-600 mb-0">Bulk Upload</h1>

              <div className="file_select_box2 w-100 d-flex gap-1 flex-column justify-content-center align-items-center p-4">
                <FileUploader
                  handleChange={handleChange}
                  name="file"
                  types={fileTypes}
                  onTypeError={(error) => {
                    toast.error(error);
                  }}
                  dropMessageStyle={{
                    backgroundColor: "#c2c2c2",
                    color: "transparent",
                    border: 0,
                  }}
                >
                  <div className="d-flex gap-2 flex-column justify-content-center align-items-center">
                    <div className="d-flex gap-2 flex-column justify-content-center align-items-center">
                      <Image
                        src={SvgImages.select_file}
                        style={{
                          height: 36,
                          filter: ImageFilters.lightGrey.filter,
                        }}
                      />
                      <h2 className="primary fs-14  fw-500 mb-0">
                        Drag and drop file here
                      </h2>
                    </div>

                    <h3 className="subText fs-14  fw-500 mb-0">OR</h3>

                    <ButtonWithIcon
                      text={"Browse Files"}
                      icon={SvgImages.file}
                    />

                    <h3 className="subText fs-12  fw-400 mb-0 mt-2 text-center">
                      We only support CSV and Excel format here. Here's a sample
                      of how it should look like
                    </h3>
                  </div>
                </FileUploader>
                <a
                  href={
                    ApiConstants.FILE_FETCH_URL +
                    "Sample/StateData.xlsx"
                  }
                  className="primary fs-14 fw-600 mb-0"
                  style={{ borderBottom: "1px solid #14489f", zIndex: 999 }}
                >
                  Click to Download Sample File
                </a>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
